(function(){
  function qs(s,c){return (c||document).querySelector(s)}
  function qsa(s,c){return Array.from((c||document).querySelectorAll(s))}
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-nd-open]')){var d=qs('[data-nd-drawer]');if(d){d.classList.add('is-open');d.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden'}}
    if(e.target.closest('[data-nd-close]')){var d=qs('[data-nd-drawer]');if(d){d.classList.remove('is-open');d.setAttribute('aria-hidden','true');document.documentElement.style.overflow=''}}
  });
  qsa('[data-price-slider]').forEach(function(box){
    var a=qs('[data-range-min]',box),b=qs('[data-range-max]',box),ha=qs('[data-hidden-min]',box),hb=qs('[data-hidden-max]',box),la=qs('[data-min-label]',box),lb=qs('[data-max-label]',box);
    function sync(changed){var av=+a.value,bv=+b.value;if(av>bv){if(changed===a)b.value=av;else a.value=bv}av=+a.value;bv=+b.value;ha.value=av>0?av:'';hb.value=bv<+b.max?bv:'';la.textContent=Math.round(av).toLocaleString('en-IN');lb.textContent=Math.round(bv).toLocaleString('en-IN')}
    a&&a.addEventListener('input',function(){sync(a)});b&&b.addEventListener('input',function(){sync(b)});
  });
  qsa('[data-nd-sort]').forEach(function(sel){sel.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',this.value);location.href=u.toString()})});

  /* Nymbus search interpreter: turns collector language into Shopify filter parameters. */
  var phrases=[
    [/\bwide[ -]?body\b/ig,'filter.p.m.custom.body_type','Wide Body'],
    [/\bnarrow[ -]?body\b/ig,'filter.p.m.custom.body_type','Narrow Body'],
    [/\bvinyl\b|\brecords?\b|\blps?\b/ig,'filter.p.m.custom.catalogue_type','Vinyl'],
    [/\b(1950s|1960s|1970s|1980s|1990s)\b/ig,'filter.p.m.custom.decade','$1'],
    [/\bcontemporary\b/ig,'filter.p.m.custom.decade','Contemporary'],
    [/\bjazz\b/ig,'filter.p.m.custom.genre_theme','Jazz'],
    [/\bclassical\b/ig,'filter.p.m.custom.genre_theme','Classical'],
    [/\bbollywood\b/ig,'filter.p.m.custom.genre_theme','Bollywood'],
    [/\bsoundtracks?\b|\bost\b/ig,'filter.p.m.custom.genre_theme','Soundtracks'],
    [/\beasy listening\b/ig,'filter.p.m.custom.genre_theme','Easy Listening'],
    [/\brock\b/ig,'filter.p.m.custom.genre_theme','Rock'],
    [/\bhindi\b/ig,'filter.p.m.custom.language','Hindi'],
    [/\burdu\b/ig,'filter.p.m.custom.language','Urdu'],
    [/\b1:(200|400|500)\b/ig,'filter.p.m.custom.scale','1:$1'],
    [/\bboeing\b/ig,'filter.p.m.custom.aircraft_maker','Boeing'],
    [/\bairbus\b/ig,'filter.p.m.custom.aircraft_maker','Airbus'],
    [/\blufthansa\b/ig,'filter.p.m.custom.airline_operator','Lufthansa'],
    [/\bqatar airways\b/ig,'filter.p.m.custom.airline_operator','Qatar Airways'],
    [/\bemirates\b/ig,'filter.p.m.custom.airline_operator','Emirates'],
    [/\bsingapore airlines\b/ig,'filter.p.m.custom.airline_operator','Singapore Airlines'],
    [/\bcathay pacific\b/ig,'filter.p.m.custom.airline_operator','Cathay Pacific'],
    [/\bqantas\b/ig,'filter.p.m.custom.airline_operator','Qantas']
  ];
  function collectorParse(raw){
    var rest=raw, params=[];
    var under=rest.match(/\bunder\s*(?:₹|rs\.?|inr)?\s*([0-9,]+)/i);if(under){params.push(['filter.v.price.lte',under[1].replace(/,/g,'')]);rest=rest.replace(under[0],' ')}
    var over=rest.match(/\b(?:over|above)\s*(?:₹|rs\.?|inr)?\s*([0-9,]+)/i);if(over){params.push(['filter.v.price.gte',over[1].replace(/,/g,'')]);rest=rest.replace(over[0],' ')}
    phrases.forEach(function(x){var m=rest.match(x[0]);if(m){var match=m[0], val=x[2];if(val.indexOf('$1')>-1){var mm=match.match(x[0]);if(mm&&mm[1])val=val.replace('$1',mm[1])}params.push([x[1],val]);rest=rest.replace(x[0],' ')}});
    rest=rest.replace(/\s+/g,' ').trim();return {rest:rest,params:params}
  }
  qsa('form[action*="/search"]').forEach(function(form){
    var input=qs('input[name="q"]',form);if(!input)return;
    form.addEventListener('submit',function(){
      qsa('[data-nd-generated]',form).forEach(function(n){n.remove()});
      var parsed=collectorParse(input.value);if(!parsed.params.length)return;
      parsed.params.forEach(function(p){var h=document.createElement('input');h.type='hidden';h.name=p[0];h.value=p[1];h.setAttribute('data-nd-generated','1');form.appendChild(h)});
      if(parsed.rest){input.value=parsed.rest}else{input.removeAttribute('name');form.action='/collections/all'}
    });
  });
})();
